@if (visibleParticipants().length) {
  <div class="ui-avatar-group">
    @for (participant of visibleParticipants(); track $index) {
      @if (clickable()) {
        <button
          type="button"
          class="ui-avatar-group__button"
          [attr.aria-label]="participant.label"
          (click)="onParticipantClick(participant)"
        >
          <ui-avatar
            class="ui-avatar-group__avatar"
            [label]="participant.label"
            [imageSrc]="participant.avatarSrc ?? null"
            size="sm"
            shape="circle"
            tone="primary"
            [uiTooltip]="participant.label"
            uiTooltipPosition="top"
          />
        </button>
      } @else {
        <ui-avatar
          class="ui-avatar-group__avatar"
          [label]="participant.label"
          [imageSrc]="participant.avatarSrc ?? null"
          size="sm"
          shape="circle"
          tone="primary"
          [uiTooltip]="participant.label"
          uiTooltipPosition="top"
        />
      }
    }
    @if (overflowCount() > 0) {
      <span class="ui-avatar-group__overflow">+{{ overflowCount() }}</span>
    }
  </div>
}
